import { apiInstance, gql } from "@/services/httpAdapter";
import { errorLogger } from "@Common/helpers/logger";

export async function getCustomerEngagementTrail(locationId, commissionCycleId) {
	const query = gql`
		query getCustomerEngagementTrail($locationId: String!, $commissionCycleId: String!) {
			getCustomerEngagementTrail(locationId: $locationId, commissionCycleId: $commissionCycleId) {
				_id
				locationId
				commissionCycleId
				engagementInfo {
					_id
					cxmActivityId
					activity
					action
					activityType
					activityTimeStampUtc
					activityInitiatedByUserId
					cxmId
					partnerId
					initiatedByUser {
						fullName
					}
					customerName {
						firstName
						middleName
						lastName
					}
					callData {
						note
					}
					noteData {
						note
					}
					emailData {
						mailSentByUserName
						emailSentByUserId
						emailSubject
						emailBody
					}
					emailOpenData {
						emailOpenDate
					}
					dmsData {
						dealDate
						inventory
					}
					appointmentData {
						appointmentSetByUserName
						appointmentSetByUserId
					}
					smsData {
						body
					}
				}
			}
		}
	`;

	const variables = {
		locationId,
		commissionCycleId,
	};
	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.getCustomerEngagementTrail;
	} catch (err) {
		errorLogger(err, { function: "getCustomerEngagementTrail", message: "Failed to get customer engagement trail", variables });
		return null;
	}
}
